import { api } from 'api'
import { useMutation } from '@tanstack/react-query'
import { toaster } from 'uikit/Toaster'

export const useResetPassword = (id: string) => {
  return useMutation({
    mutationFn: (data) => api.keycloak.updatePasswordUserItem(id, data),
    onError: () => {
      toaster.create({
        title: 'Ошибка',
        description: 'Не удалось установить пароль',
        type: 'error',
      })
    },
    onSuccess: () => {
      toaster.create({
        title: 'Готово',
        description: 'Пароль успешно установлен',
        type: 'success',
      })
    }
  })
}
